import * as React from "react";
const SvgEndWorkflowMinimalIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 7, y: 7, width: 10, height: 10, fill: "currentColor" }));
export default SvgEndWorkflowMinimalIcon;
